export const NAMED_COLORS = {
  black: '#000000',
  charcoal: '#31393f',
  cyan: '#2eb6ff',
  darksteel: '#417ba4',
  gold1: '#ffffed',
  gold2: '#f7e094',
  gold3: '#edd077',
  gray1: '#fafbfc',
  gray2: '#485a66',
  gray3: '#323a41',
  green1: '#edfffd',
  green2: '#7ee0d7',
  green3: '#45c7ba',
  heather: '#adbfcc',
  powder1: '#f2faff',
  powder3: '#afdcfa',
  red1: '#fff5f2',
  red2: '#f5897a',
  royal: '#0970c5',
  slate1: '#f5fafd',
  slate2: '#e7eff5',
  slate2Shadow: '#d3e0e8',
  slate3: '#d3e0e8',
  slate4: '#aebfcc',
  slate5: '#7a8c99',
  slate6: '#5f707c',
  steel: '#94b9d4',
  white: '#ffffff',
}

export default {
  primary: {
    main: NAMED_COLORS.royal,
  },
  error: {
    main: '#df554d',
    light: NAMED_COLORS.red1,
    dark: NAMED_COLORS.red2,
  },
  info: {
    main: NAMED_COLORS.cyan,
    light: NAMED_COLORS.powder1,
    dark: NAMED_COLORS.powder3,
  },
  success: {
    main: NAMED_COLORS.green3,
    light: NAMED_COLORS.green1,
    dark: NAMED_COLORS.green2,
  },
  warning: {
    main: NAMED_COLORS.gold3,
    light: NAMED_COLORS.gold1,
    dark: NAMED_COLORS.gold2,
  },
  common: NAMED_COLORS,
  brand: {
    color: NAMED_COLORS.royal,
    light: '#0b99e6',
    dark: '#074294',
    darkest: '#19427d',
    shadow: '#06467c',
  },
  altBrand: {
    color: '#f2faff',
    light: '#f5f9fc',
    dark: '#afdcfa',
    shadow: '#001d35',
  },
  accent: {
    color: '#0d61a6',
    semiLight: NAMED_COLORS.cyan,
    light: '#66d1ff',
    dark: '#0092e1',
    shadow: NAMED_COLORS.cyan,
  },
  background: {
    color: NAMED_COLORS.slate1,
    colorDark: '#ebf4fc',
  },
}
